var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-wrap kiwi-wrap-error"},[_c('h2',[_vm._v("Kiwi IRC could not start :(")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3613e78a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartupError.vue
// module id = o60X
// module chunks = 1